import { gqlOperation } from '…/app/common/rpc/gqlOperation.mts';

import CREATE_WORKSPACE from './createWorkspace.gql';

interface CreateWorkspaceInput {
  name: string;
  organizationType?: string;
  pricingPlan: string;
  timezone: string;
  workspaceType?: string;
}

export function createWorkspace({
  name,
  organizationType,
  pricingPlan,
  timezone,
  workspaceType,
}: CreateWorkspaceInput): Promise<string> {
  return gqlOperation<{ createWorkspace: { id: string } }>(CREATE_WORKSPACE, {
    name,
    organizationType,
    pricingPlan,
    timezone,
    workspaceType,
  })
    .then(({ createWorkspace: { id } }) => id);
}
